<template>
    <div style="background: #FFFFFF;min-height:800px;">
        <el-row>
            <el-col class="title" :span="24">个人经验</el-col>
        </el-row>
        <el-row class="levelView" :gutter="20">
            <el-col class="leftView" :span="5">
                <div class="leftItem">
                    <div class="currentLevelTitle"><img class="icon" src="../../../assets/img/activityCenter/levelValue.png" />&nbsp;您当前的经验值</div>
                    <div class="currentLevel">{{ currentLevel }}</div>
                </div>
            </el-col>
            <el-col class="centerView" :span="5">
                <div class="centerItem">
                    <div class="currentLevelTitle"><img class="icon" src="../../../assets/img/activityCenter/levelName.png" />&nbsp;您当前的称号</div>
                    <div class="currentLevel">{{ currentTitle }}</div>
                </div>
            </el-col>
            <el-col class="rightView" :span="14">
                <div class="rightItem">
                    <div class="currentLevelTitle"><img class="icon" src="../../../assets/img/activityCenter/levelTips.png" />&nbsp;您当前的等级:<span class="tips">{{ currentLevelTitle }}</span></div>
                    <div class="currentLevel">
                        <template>
                            <div>
                                <div class="levelModel">
                                    <div v-for="(item,index) in activitySteps.slice(0, activitySteps.length - 1)" :key="index" style="width: 30%">
                                        <div class="x">
                                            <div class="timeDesc" style="">
                                                <div :class="[item.levelPress < 100 && item.levelPress != 0 ? 'levelCss' : 'levelCuCss']">{{ item.nodename }}</div>
                                            </div>
                                        </div>
                                        <div  class="pressPointA" :style="{  width: '100%', height: pressheight + 'px', backgroundColor: pressAcolor,  }" >
                                            <div :class="[item.levelPress < 100 ? 'pointCss' : '']"  :style="{ width: item.levelPress + '%', height: '100%', backgroundColor: pressBcolor, }" ></div>
                                        </div>
                                    </div>
                                    <div style="width: 10%">
                                        <div class="x">
                                            <div class="timeDesc" style="">
                                                <div class="levelCuCss">
                                                    {{ lastactivitySteps.nodename }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
            <el-col class="levelTitle" :span="24">最近经验记录</el-col>
            <el-col class="levelTable" :span="18">
                <el-table
                :data="tableData"
                :header-cell-style="{'text-align':'center','background':'#EEF7FF'}"
                :cell-style="{'text-align':'center'}"
                border
                stripe
                style="width: 100%">
                <el-table-column
                prop="historyTime"
                label="日期"
                width="160">
                </el-table-column>
                <el-table-column
                prop="historyDate"
                label="时间"
                width="160">
                </el-table-column>
                <el-table-column
                prop="behavior"
                label="增加经验值原因">
                </el-table-column>
                <el-table-column
                prop="experienceValueStr"
                label="增加经验值数额"
                width="160">
                </el-table-column>
            </el-table>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { getLevelInfomation } from '@/api/modules/personalInfomation'
export default {
  name: 'Experience',
  data() {
    return {
      currentLevel: 0,
      currentTitle: '',
      currentLevelTitle: '',
      tableData: [],
      // 进度条大小
      pressheight: 12,
      // 进度条背景颜色
      pressAcolor: '#DCDFE6',
      // 进度条颜色
      pressBcolor: '#FE7146',
      lastactivitySteps: {},
      activitySteps: [],
      // 当前等级
      currentLevelFraction: null,
      // 最高等级
      highestLevel: null
    }
  },
  created() {
    this.getLevelInfomation()
  },
  methods: {
    async getLevelInfomation() {
      const res = await getLevelInfomation()
      if (res.code === 0) {
        this.highestLevel = res.data.level.maxLevel
        this.currentLevelFraction = res.data.level.level
        this.currentTitle = res.data.level.levelName
        this.currentLevel = res.data.level.exp
        this.tableData = res.data.history

        var levelInt = parseFloat(this.currentLevelFraction)
        var integer = Math.trunc(levelInt)
        var decimal = levelInt - integer
        var levelDataArray = []
        this.currentLevelTitle = 'Lv.' + integer
        for (var i = 0; i < integer; i++) {
          var dataItemF = { levelPress: 100, nodename: i }
          levelDataArray.push(dataItemF)
        }
        var dataItemC = { levelPress: decimal * 100, nodename: integer }
        levelDataArray.push(dataItemC)

        for (var j = 0; j < this.highestLevel - levelInt; j++) {
          var dataItemE = { levelPress: 0, nodename: integer + j + 1 }
          levelDataArray.push(dataItemE)
        }
        this.timestoneCompute(levelDataArray)
      }
    },
    timestoneCompute(stepdata) {
      this.activitySteps = stepdata
      this.lastactivitySteps = stepdata[stepdata.length - 1]
    }
  }
}
</script>
<style scoped>
.title{
    padding: 30px 0px;
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    color: #2F374B;
    line-height: 30px;
}
.levelView{
    padding: 0px 20px;
    height: 155px;
}
.leftView{
    height: 100%;
    border-radius: 4px;
}
.centerView{
    height: 100%;
    border-radius: 4px;
}
.rightView{
    height: 100%;
    border-radius: 4px;
}
.leftItem{
    height: 100%;
    border: 1px solid #DDDDDD;
    text-align: center;
}
.centerItem{
    height: 100%;
    border: 1px solid #DDDDDD;
    text-align: center;
}
.rightItem{
    height: 100%;
    border: 1px solid #DDDDDD;
    text-align: center;
}
.levelTitle{
    padding: 0px 16px;
    height: 40px;
    font-size: 18px;
    font-weight: 400;
    color: #2F374B;
    line-height: 40px;
}
.levelDetails{
    padding: 0px 16px;
    height: 24px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
}
.levelTable{
    padding: 30px 16px;
}
.currentLevelTitle{
    margin-top: 31px;
    font-size: 20px;
    font-weight: 400;
    color: #2F374B;
    line-height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.currentLevel{
    font-size: 30px;
    font-weight: 400;
    font-style: italic;
    color: #E03A24;
    line-height: 46px;
}
.icon{
    width: 30px;
    height: 30px;
}
.tips{
    font-size: 30px;
    font-weight: 400;
    font-style: italic;
    color: #E03A24;
    line-height: 46px;
}
.x {
  position: absolute;
  background-color: white;
  width: 2px;
  height: 15px;
}
.timeDesc {
  position: relative;
  height: 100px;
  padding-top: 20px;
}
.pointCss {
  border-radius: 0px 20px 20px 0;
}
.levelCss {
    background-color: #E03A24;
    width: 20px;
    height: 20px !important;
    border-radius: 16px;
    color: white;
    font-style: normal;
    font-size: 16px;
    line-height: 20px;
    left: -8px;
    position: absolute;
}
.levelCuCss {
    height: 20px;
    font-size: 16px;
    line-height: 30px;
    font-style: normal;
    line-height: 20px;
    left: -4px;
    position: absolute;
}
.levelModel {
    display: flex;
    height: 125px;
    padding: 0 20px 20px 20px;
}
</style>
